import { StatusMap } from '@/config/SensorStatuses';

const tableColumns = [
  {
    prop: 'barcode',
    label: 'Barcode',
    sortable: true,
    width: 130
  },
  {
    prop: 'lastReported',
    label: 'Last Activity',
    sortable: false,
    width: 140
  },
  {
    prop: 'batteryLevel',
    label: 'Battery',
    sortable: false,
    width: 130
  },
  {
    prop: 'hasLocation',
    label: 'GPS',
    sortable: false,
    width: 100
  },
  {
    prop: 'currentStatus',
    label: 'Status',
    sortable: false,
    width: 100
  },
  {
    prop: 'pestTypeName',
    label: 'Pest Type',
    sortable: false,
    width: 150
  },
  {
    prop: 'orchardCount',
    label: '',
    sortable: false,
    width: 200
  },
  {
    prop: 'isSensorBiosecurity',
    label: 'Biosecurity',
    sortable: true
  }
];

const groupTableColumns = [
  {
    prop: 'barcode',
    label: 'Barcode',
    sortable: true,
    width: 130
  },
  {
    prop: 'pestTypeName',
    label: 'Pest Type',
    sortable: false,
    width: 150
  },
  {
    prop: 'sensorName',
    label: 'Name',
    sortable: false,
    width: 180
  },
  {
    prop: 'dateDeployed',
    label: 'Deployed on',
    sortable: false,
    width: 350
  },
  {
    prop: 'dateRemoved',
    label: 'Removed on',
    sortable: false,
    width: 350
  },
  {
    prop: 'isSensorBiosecurity',
    label: 'Biosecurity',
    sortable: true
  }
];

const tableFilters = Object.entries(StatusMap).map(function(s) {
  return {
    name: `${s[1]}`,
    label: `${s[1]}`,
    search: 'status',
    param: `${s[0]}`
  }
})

const tableOptions = {
  'default-sort': {
    prop: 'createdOn',
    order: 'desc'
  },
  limit: 10,
  searchParams: {
    default: 'barcode',
    params: [
      {
        label: 'Barcode',
        value: 'barcode'
      },
      {
        label: 'Imei',
        value: 'imei'
      },
      {
        label: 'Iccid',
        value: 'iccid'
      }
    ]
  }
};

export { tableColumns, tableFilters, tableOptions, groupTableColumns };
